// Ionic & Angular Imports
import {Component} from '@angular/core';
import {AlertController} from 'ionic-angular';

// Providers Imports
import {rsReportSvc, IReportDetails} from '../../../services/report.service';

// Component Imports
import {BasePage} from '../../base.component';


@Component({
    templateUrl: 'tab-weather.html',
})
export class WeatherReportTab extends BasePage
{
    private report : IReportDetails = undefined;

    constructor(
        protected alertCtrl : AlertController,
        private reportSvc : rsReportSvc
    ){
        // Construct base class
        super( alertCtrl );

        // Retrieve the active report
        this.report = reportSvc.getActiveReport();
    }
}


// WEBPACK FOOTER //
// ./src/pages/report/tab-weather/tab-weather.component.ts